import React from 'react';
import PropTypes from 'prop-types';
import gettext from '@eb/gettext';
import isEmpty from 'lodash/isEmpty';
import omit from 'lodash/omit';
import { loadReCaptcha } from 'react-recaptcha-v3';

import { NotificationBar } from '@eb/eds-notification';
import { withMainControls } from '@eb/eds-structure';

import { ICON_TYPE_PROP_TYPE } from '@eb/eds-icon';
import { TYPE_ERROR } from '@eb/eds-notification';
import { AlertChunky } from '@eb/eds-iconography';

import PageHeader from '../../components/PageHeader';
import LogInForm from '../../components/newForms/LoginForm';
import SplitContainer from '../../connectedComponents/SplitContainer';

/**
 * List of urls that will lead to this page:
 * * BASE_URL/SOCIAL_LINK_LOGIN_PATH
 */
class SocialLinkPage extends React.PureComponent {
    static propTypes = {
        onLinkAccountsOnLogin: PropTypes.func,
        email: PropTypes.string,
        handleForgotPassword: PropTypes.func,
        moveBack: PropTypes.func,
        clearAuthNotification: PropTypes.func,
        recaptcha2PublicKey: PropTypes.string,
        recaptcha3PublicKey: PropTypes.string,
        disableRecaptcha3: PropTypes.bool,
        showCaptcha: PropTypes.bool,
        usesNewStyles: PropTypes.bool,
        authNotificationOptions: PropTypes.shape({
            message: PropTypes.node,
            type: PropTypes.string,
            iconType: ICON_TYPE_PROP_TYPE,
        }),
    };

    componentDidMount() {
        if (!this.props.disableRecaptcha3) {
            loadReCaptcha(this.props.recaptcha3PublicKey);
        }
    }

    _handleSubmit = (formData) => {
        const { clearAuthNotification, onLinkAccountsOnLogin } = this.props;

        // clear notification everytime form is submitted
        if (clearAuthNotification) {
            clearAuthNotification();
        }

        return onLinkAccountsOnLogin(formData);
    };

    _handleShowNotification = (error) => {
        const { addMainNotification } = this.props;

        /*Limit the call to addMainNotification to only if
        a notification hasn't been shown since last submit.*/
        if (!this._hasNotification) {
            addMainNotification({
                type: TYPE_ERROR,
                children: error,
                iconType: <AlertChunky />,
            });

            this._hasNotification = true;
        }
    };

    _handleClearNotification = () => {
        const { hideMainNotification } = this.props;

        this._hasNotification = false;
        hideMainNotification && hideMainNotification();
    };

    render() {
        const {
            handleForgotPassword,
            recaptcha2PublicKey,
            recaptcha3PublicKey,
            showCaptcha,
            email,
            moveBack,
            authNotificationOptions,
            disableRecaptcha3,
            clearAuthNotification,
            socialData,
            usesNewStyles,
        } = this.props;

        let pageHeaderProps = {
            headerText: gettext('You look familiar'),
            subtitleText: gettext(
                'An Eventbrite account with your email already exists. Enter your password to continue.',
            ),
        };

        const buttonCTA = gettext('Link account');

        // hide subtitle when an auth notification is being displayed
        if (!isEmpty(authNotificationOptions)) {
            pageHeaderProps = omit(pageHeaderProps, 'subtitleText');
        }

        return (
            <SplitContainer
                shouldShowSecondaryPanel={usesNewStyles}
                usesNewStyles={usesNewStyles}
                header={<PageHeader {...pageHeaderProps} />}
            >
                <LogInForm
                    buttonCTA={buttonCTA}
                    onSubmit={this._handleSubmit}
                    clearAuthNotification={clearAuthNotification}
                    handleEmailEdit={moveBack}
                    handleForgotPassword={handleForgotPassword}
                    recaptcha2PublicKey={recaptcha2PublicKey}
                    recaptcha3PublicKey={recaptcha3PublicKey}
                    disableRecaptcha3={disableRecaptcha3}
                    showCaptcha={showCaptcha}
                    email={email}
                    showNotification={this._handleShowNotification}
                    clearNotification={this._handleClearNotification}
                    socialData={socialData}
                />
            </SplitContainer>
        );
    }
}

export default withMainControls(SocialLinkPage);
